module.exports = __webpack_public_path__ + "img/download-icon.7a123896.svg";